<ng-container *ngIf="!requestSent; else successContent">
  <h2 mat-dialog-title>{{title}}</h2>
  <mat-dialog-content>
    <p>{{description}}</p>
    <p *ngIf="errorMessage" class="basic-plan-upgrade-error" role="alert">{{errorMessage}}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false" [disabled]="isSubmitting">No</button>
    <button mat-flat-button color="primary" [disabled]="isSubmitting"
            (click)="requestUpgrade()" cdkFocusInitial>
      {{isSubmitting ? 'Sending...' : 'Yes'}}
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-template #successContent>
  <h2 #successHeading mat-dialog-title tabindex="-1">Upgrade Request Sent</h2>
  <mat-dialog-content>
    <p role="status" aria-live="polite">
      Your upgrade request was sent to Support. Our team will contact you shortly.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" [mat-dialog-close]="true">Close</button>
  </mat-dialog-actions>
</ng-template>
